<template>
  <div class="transfer">
    <div>
		
      <div class="tips">
        <!-- <div> {{UserInfo.accountName}}</div> -->
      </div>

      <div class="copy-body">
        <div class="copy-body-title">Please enter your mobile number</div>
        <!-- <div class="WEMA-bank">
          <div class="title">WEMA Bank</div>
          <div class="number"
               v-clipboard:copy="value"
               v-clipboard:success="firstCopySuccess"
               v-clipboard:error="firstCopyError"
          >{{UserInfo.accountNumber || 0}}<img src="../assets/images/copy@2x.png"/></div>
          <div class="line"></div>
          <div class="remark">Above beneficiary account will expire after <span>{{count}} </span></div>
        </div> -->
		
		<div class="Mpesa-bank">
			<!--  
				<div class="Mpesa-input">
					<input type="number" v-model="List.mobile" placeholder="Enter Phone Number"/>
				</div>
			-->
			
			<div class="Mpesa-input" style="display: flex; align-items: center; border: 1px solid #333; box-shadow: none; border-radius: 0.2rem;">
		    <div style="margin-left: 0.02rem;height: 1.2rem;width: 1.6rem;display: flex;justify-content: center;align-items: center;box-shadow: none;background: #f1f1f1;border-radius: 0.2rem 0 0 0.2rem;">
		      <span style="font-size: 0.35rem; color: #000;">+254</span>
		    </div>
		    <input v-model="List.mobile" type="number" placeholder="Enter Mobile Number" style="outline: none; box-shadow: none;border:none">
		  </div>
  
		</div>
      </div>

      <!--      -->
      <div class="remarks">
        <img src="../assets/images/icon@2x.png"/>
        <div class="text">You will get a confirmation once we receive your payment</div>
      </div>
      <!--      -->
      <div class="payment" @click="payment">{{ payBtn }}</div>


      <!--      <div class="copy_number">-->
      <!--        <div class="number" v-clipboard:copy="value" v-clipboard:success="firstCopySuccess"-->
      <!--             v-clipboard:error="firstCopyError">{{UserInfo.accountNumber}}-->

      <!--        </div>-->
      <!--        <div class="bank">{{UserInfo.transferBankName}}</div>-->
      <!--        <div class="remarks1">Above beneficiary account will expire after <span>{{count}} </span></div>-->
      <!--      </div>-->
      <!--      <div class="remarks">You will get a confirmation once we receive your payment</div>-->
      <!--      <div class="payment" @click="payment">I Have Paid , Check now</div>-->
    </div>
    <!--    <div class="loading">-->
    <!--      <van-loading color="#1989fa" size="60px" v-show="flag"/>-->
    <!--    </div>-->


  </div>
</template>
<script>
import { Locale } from 'vant'
  export default {
    data() {
      return {
        value: '',
        flag: false,
        code: Number,
        status: false,
        request_flag: true,
        payBtn: 'Make Payment',
        
        List: {
			mobile:'',
			email:''
		},
        count: '', //倒计时
        seconds: 0 // 10天的秒数

      }
    },
    mounted() {
      this.getParams()

      // this.getInfo()
      this.value = this.UserInfo.accountNumber || '0'
    },
    props: ['Params', 'UserInfo'],
    watch: {
      UserInfo(val) {
        this.value = this.UserInfo.accountNumber
        this.Time(this.UserInfo.timeoutSeconds) //调用定时器
      }
    },
    methods: {
      // 点击 pay
      /**
       * 订单状态 0 待支付 1 已支付 2 已失效
       private Integer status;
       *
       */
      payment() {
        console.log(this.List)
        if (!this.request_flag) {
          return
        }
        
        this.$toast('Payment Proceed')
        this.payBtn = "Payment Proceed";
		const that = this;
        this.request_flag = false
        this.flag = true // 加载中...
        // const sign = localStorage.getItem('sign')
        const timestamp = new Date().getTime()
        const curURL = '/api/order/submitSecond'
				const data ={
					merchantId:that.List.merchantId,
					merchantOrderId:that.List.merchantOrderId,
					amount:that.Params.amount,
					timestamp:timestamp,
					sign:that.List.sign,
					mobile:that.List.mobile,
					email:that.List.email
				}

        this.axios.post(curURL,data).then(res => {
          console.log(res.data.data.status)
          if (res.data.data.status == 0) {
            // 待支付
            this.flag = false
            this.$toast('Your money will be comfirmed in few minutes')
          } else if (res.data.data.status == 1) {
            // this.$toast('Payment success')
            // this.$router.push({path: '/success', query: {'image': this.UserInfo.logoUrl}})
            if(res.data.data.callbackUrl!='' && res.data.data.callbackUrl.startsWith('http')){
            	window.location.href=res.data.data.callbackUrl
            }else{
                this.$router.push({path: '/success', query: {'image': this.UserInfo.logoUrl}})
            }
			
          } else if (res.data.data.status == 2) {
            // this.$toast('Failure to pay')
            this.$router.push({path: '/timeout', query: {'image': this.UserInfo.logoUrl}})
          }
          this.request_flag = true
        })
      },
      firstCopySuccess(e) {
        this.$toast("Account copied successfully!")
      },
      firstCopyError(e) {
        console.log(e)
        this.$toast("Fail!")
      },
      // DateTime(){
      //     let date = new Date(this.UserInfo.paymentOutTime)
      //     let time1 = date.getTime()
      //     let time_now = Date.now()
      //     if(time1-time_now>0){

      //     }
      // },
      // 天 时 分 秒 格式化函数
      // countDown() {
      //   // let d = parseInt(this.seconds / (24 * 60 * 60))
      //   // d = d < 10 ? "0" + d : d
      //   // let h = parseInt(this.seconds / (60 * 60) % 24);
      //   // h = h < 10 ? "0" + h : h
      //   let m = parseInt(this.seconds / 60000 % 60);
      //   m = m < 10 ? "0" + m : m
      //   let s = parseInt((this.seconds / 1000) % 60);
      //   s = s < 10 ? "0" + s : s
      //   this.count = m + ':' + s
      //   // console.log(m)
      // },
      getTimes(t) {
        let h = parseInt(t / 60 / 60 % 24)
        let m = parseInt(t / 60 % 60)
        let s = parseInt(t % 60)
        //三元表达式 补零 如果小于10 则在前边进行补零 如果大于10 则不需要补零
        h = h < 10 ? '0' + h : h
        m = m < 10 ? '0' + m : m
        s = s < 10 ? '0' + s : s
        return `${m}:${s}`
      },
      Time(t) {
        let second = t
        const timeDetail = setInterval(() => {
          second -= 1
          this.count = this.getTimes(second)
          console.log(this.getTimes(second))
          if (second <= 0) {
            clearInterval(timeDetail)
            this.$toast('Order has expired！')
          }
        }, 1000)
        // let date = new Date(this.UserInfo.paymentOutTime.replace(/-/g, '/'))
        // let time1 = date.getTime()
        // let time_now = Date.now()
        // this.seconds = time1 - time_now
        // var timeDatail = setInterval(() => {
        //   this.seconds -= 1000
        //   this.countDown()
        //   if (this.seconds <= 0) {
        //     clearInterval(timeDatail)
        //     this.count = "00:00"
        //     this.$toast('Order has expired！')
        //   }
        // }, 1000)
      },

      getParams() {
        this.List = this.$route.query
		console.log(this.$route)
      }
    }
  }
</script>

<style scoped lang="scss">

  .remarks {
    display: flex;
    align-items: start;

    font-size: 0.24rem;
    text-align: start;

    .text {
      margin-left: 0.08rem;
    }

    img {
      width: 0.26rem;
      height: 0.26rem
    }
  }
  .Mpesa-bank{
	  .Mpesa-input{
		 margin-top: 0.2rem;
		  input{
			  border: none;
			  padding:  0.24rem 0.32rem;
			  width: 5.3rem;
			  height: 0.4rem;
			  border-radius: 0.1rem;
			  font-size: 0.35rem;
			  border:1px solid #727272;
			  color: #333333 !important;
			  
		  }
	  }
  }

  .WEMA-bank {
    padding: 0.24rem 0.32rem;
    margin-top: 0.2rem;

    background: #E4F6FD;
    border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
    border: 0.02rem solid #4544DF;

    .remark {
      color: #999999;
      font-size: 0.22rem;
      margin-top: 0.48rem;
    }

    .line {
      width: 5.36rem;
      height: 0.1rem;
      background: #FFFFFF;
      box-shadow: 0rem 0.03rem 0.06rem 0.01rem rgba(0, 0, 0, 0.04);
      border-radius: 0.05rem 0.05rem 0.05rem 0.05rem;
      margin-top: 0.37rem;
    }

    .number {
      margin-top: 0.08rem;
      font-size: 0.49rem;
      font-weight: bold;
      color: #4544DF;

      img {
        height: 0.3rem;
        width: 0.3rem;
        margin-left: 0.07rem;
      }
    }

    .title {
      font-size: 0.26rem;
      color: #333333;
      font-weight: bold;
    }
  }

  .copy-body-title {
    font-size: 0.26rem;
    color: #333333;
    text-align: start;
    font-weight: bold;
    margin-top: 0.44rem;
  }

  .transfer {
    padding: 0.62rem 0.4rem 0.59rem 0.4rem;

    .van-loading {
      margin-top: 50%;
    }

    .tipsred {
      font-size: 0.26rem;
      text-align: start;
      color: #4544DF;
      margin-top: 0.24rem;
    }

    .tips {
      font-size: 0.26rem;
      text-align: start;
    }

    .copy_number {
      height: 3.5rem;
      background-color: rgba(242, 240, 252, .53);
      border-radius: 0.2rem;

      .number {
        padding-top: 0.4rem;
        color: #7535FD;
        font-size: 0.48rem;
        font-weight: bold;
        line-height: 0.8rem;

        img {
          width: 0.3rem;
          margin-left: 0.1rem;
        }
      }

      .bank {
        color: #727272;
        font-size: 0.32rem;
        line-height: 0.6rem;
      }

      .remarks1 {
        color: #727272;
        padding-top: 0.5rem;
        font-size: 0.28rem;

        span {
          font-weight: bold;
        }
      }

    }

    .remarks {
      padding-top: 0.4rem;
      font-size: 0.28rem;
    }

    .payment {
      background: #4544DF;
      border-radius: 0.1rem;
      height: 0.9rem;
      line-height: 0.9rem;
      color: #fff;
      font-size: 0.3rem;
      margin-top: 0.68rem;
    }

  }

  .loading {
    position: absolute;
    top: 30%;
    left: 50%;
    margin-left: -30px;
    z-index: 999;
  }

</style>



// WEBPACK FOOTER //
// src/components/mpesa.vue